<script setup lang="ts">
// Formkit schema: https://formkit.com/api-reference/formkit-inputs#formkitschemaextendablesection
import type { UmbracoFormField } from 'types/blocks';

const { getDefaultFormField } = useForm();

defineProps<{
  field: UmbracoFormField;
}>();
</script>

<template>
  <FormKit
    type="textarea"
    :validation-messages="{
      required: field.requiredErrorMessage || $t('FormMessages.General.Required'),
      length: $t('FormMessages.Error.MessageTooLong'),
    }"
    v-bind="getDefaultFormField(field)"
    :validation="`${field.required ? 'required' : ''}|length:0,${field.settings.maximumLength || 5000}`"
    validation-visibility="live"
    auto-height
  />
</template>
